import { useState, useEffect } from 'react';

// Breakpoints: mobile < 640px, tablet 640-1023px, desktop >= 1024px.
// Since almost every layout in this app is an inline style object (not CSS
// classes), this hook is how components adapt their grid-template-columns,
// paddings, and widths per screen size — plain CSS media queries can't
// override an inline `style` prop, so this JS-level check is the mechanism.
export function useResponsive() {
    const [width, setWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 1280);

    useEffect(() => {
        const handleResize = () => setWidth(window.innerWidth);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return {
        width,
        isMobile: width < 640,
        isTablet: width >= 640 && width < 1024,
        isDesktop: width >= 1024
    };
}